export type TabsColor = "green" | "yellow" | "red" | "white"

export const TabsColors: Record<TabsColor, string> = {
    green: "#4CAF50",
    yellow: "#F2BD00",
    red: "#F83528",
    white: "#FFF"
}